import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Tools from './Tools';
import socketIOClient from "socket.io-client";
import '../components/css/Monitor.css';
import { Dashboard, Filter, ArrowRight } from '../components/icons/svgIcons';
import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es.json';
import ReactTimeAgo from 'react-time-ago';
import { useHistory } from "react-router-dom";
import SocketActions from './SocketActions';
import Toast from './Toast';
import MoreMenu from './ui/moreMenu/MoreMenu';
import ModalWindow from './ModalWindow';
import Box from './Box';

const Monitor = (props) => {

    const [executives, setExecutives] = useState([]); 
    const [filteredExecutives, setFilteredExecutives] = useState([]); 
    const [filter, setFilter] = useState(null); 
    const [filterByQueue, setFilterByQueue] = useState(null); 
    const [sortKey, setSortKey] = useState(null); 
    const [callsInQueue, setCallsInQueue] = useState([]); 
    const [infoInQueueVisible, setInfoInQueueVisible] = useState(true); 
    const [infoCampaignsVisible, setInfoCampaignsVisible] = useState(true); 
    const [abandonmentsVisible, setAbandonmentsVisible] = useState(true); 
    const [queuedCallsDetail, setQueuedCallsDetail] = useState([]); 
    const [currentConnectedCampaigns, setCurrentConnectedCampaigns] = useState([]); 
    const [visibleModalChangeRatio, setVisibleModalChangeRatio] = useState(false);
    const [selectedCampaignToChangeRadio, setSelectedCampaignToChangeRadio] = useState(null);
    const [abandonments, setAbandonments] = useState([]);
    const [callsDialing, setCallsDialing] = useState(0);
    const [data, setData] = useState(null); 
    const [toastRef, setToastRef] = useState(React.createRef()); 

    let history = useHistory();

    useEffect(() => {
        TimeAgo.addDefaultLocale(es);

        let sessionData=JSON.parse(sessionStorage.getItem('sessionData'));
        let extension=(sessionData?sessionData.extension:'NONE');
        const socket=Tools.connectClientToSocket(socketIOClient, extension, sessionData.name, sessionData.profile_code, sessionData.hostId, 'Monitor');

        socket.on("executivesMonitor", data => {
            setExecutives(data.executives);
        });

        socket.on("callsInQueue", data => {
            setCallsInQueue(data.callsInQueue);
        });


        socket.on("queuedCallsDetail", data => {
            let dataRaw=(data.detail).replaceAll("'", '"');
            let parsedData = JSON.parse(dataRaw);
            setQueuedCallsDetail(parsedData);
        });

        socket.on("abandonmentsByQueue", data => {
            setAbandonments(data.abandonments);
        });

        socket.on("callsCurrentlyDialing", data => {
            setCallsDialing(data.dialing);
        });

        //set initial values for CALLSINQUEUE
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/currentCallsInQueue`, {
            params: {}
        })
        .then(function (response) {
            setCallsInQueue(response.data.callsInQueue);
        })
        .catch(function (error) {
            console.log("Error:", error.message);
        });


        // setTimeout(() => {
        //     console.log('🐞DEBUG socket en el monitor:', socket);
        // }, 5000); 

    }, []);

    useEffect(() => {
        if(filter){
            let fltExecutives;
            if(filter.code!=='PAUSED'){
                fltExecutives = executives.filter(ex => ex.logDetails.eventCode===filter.code);
            } else{
                fltExecutives = executives.filter(ex => 
                    ex.logDetails.eventCode!=='RINGING' &&
                    ex.logDetails.eventCode!=='ACTIVE' &&
                    ex.logDetails.eventCode!=='INGRESANDO GESTIÓN' &&
                    ex.logDetails.eventCode!=='LOGGED'
                );
            }
            setFilteredExecutives(fltExecutives);
        } else{
            setFilteredExecutives(executives);
        }


        
        if(filterByQueue){
            if(filterByQueue.type==='OUTBOUND'){
                let fltExecutives = executives.filter(ex => ex.cmpDetails.aqDetails && ex.cmpDetails.aqDetails.name===filterByQueue.queue);
                setFilteredExecutives(fltExecutives);
            }
            if(filterByQueue.type==='INBOUND'){
                const checkContainQueue=(inbq)=> {
                    if(inbq && inbq.name){
                        return inbq.name === filterByQueue.queue;
                    } else{
                        return false;
                    }
                  }
                let fltExecutives = executives.filter(ex => ex.lastInbound && ex.lastInbound.length && ex.lastInbound.some(checkContainQueue));
                setFilteredExecutives(fltExecutives);
            }
        }

        if(sortKey){
            if(sortKey==='extension'){
                filteredExecutives.sort((a, b) => Number(b.extension) - Number(a.extension));
            }
            
            if(sortKey==='executiveName'){
                filteredExecutives.sort((a, b)  => {

                    let fa = a.name.toLowerCase(),
                    fb = b.name.toLowerCase();
            
                    if (fa < fb) {
                        return -1;
                    }
                    if (fa > fb) {
                        return 1;
                    }
                    return 0;
               });
            }
        }


        //canpañas outbound CONECTADAS y avance
        let distinctCampaignIds = [];
        let distinctCampaigns = [];
        executives.forEach((exec)=> {
            if (exec.cmpDetails._id && !distinctCampaignIds.includes(exec.cmpDetails._id)) {
                distinctCampaignIds.push(exec.cmpDetails._id);
                distinctCampaigns.push(exec.cmpDetails);
            };
        });
        setCurrentConnectedCampaigns(distinctCampaigns);
       

    }, [executives, filter, filterByQueue, sortKey]);


    const supervisorLogout=()=>{
        Tools.currentSocketConnection.disconnect();

        //espera registrar logout para user los datos de
        //la sesión antes de eliminarla
        Tools.logUserStatus({ code: 'LOGOUT', desc: 'Logout' }).then(function (result) {
            sessionStorage.clear();

            if (props.softphoneInst){
                props.softphoneInst.disconnect();
            }

            document.documentElement.className = 'theme-light';
            history.push('/login');
        })
    }

    const disconnectAgent=(extension)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/remoteUserDisconnect`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                extension: extension,
            }
        };

        axios(options).then(response => {
            if (response.status === 200) {
                console.log('user disconnect');
            }
        });
    }

    const changeRatioDialing = (campaign) => {
        setVisibleModalChangeRatio(true);
        setSelectedCampaignToChangeRadio(campaign);
    }

    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const applyChangeRatioDialing = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/campaignRatio`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                campaignId: selectedCampaignToChangeRadio._id,
                ratioDialing: data.ratioDialing,
                campaignDialerQueue: selectedCampaignToChangeRadio.aqDetails.dialerQueue
            }
        };
        axios(options).then(response => {
            setVisibleModalChangeRatio(false);
            toastRef.current.addToast('Se modificó el ratio de campaña', 5000);
            setTimeout(() => window.location.reload(), 3000); 
        });
    }

    
    return (
        <div className="monitor">  
            <h1 className='title'><Dashboard/>Dashboard</h1>
            <SocketActions />
            <Toast ref={toastRef}></Toast>
            <a className='sessionCloseButton' onClick={supervisorLogout}>Cerrar sesión</a>

            {visibleModalChangeRatio ? (
                <ModalWindow closeMethod={() => { setVisibleModalChangeRatio(false) }}>
                    <h2 className='title'>Modificar ratio de discado</h2>
                    <span className="upper subtitle">Seleccione el ratio de discado para la<br />campaña seleccionada</span>
                    <div className="flexRow">
                        <div className="flexCol">
                            <Box type="select" name="ratioDialing" label="ratio" className="x2" placeholder="Seleccione ..." options={[{ ratio: 1, desc: '1' }, { ratio: 1.5, desc: '1.5' }, { ratio: 2, desc: '2' }, { ratio: 2.5, desc: '2.5' }, { ratio: 3, desc: '3' }]} onChange={handleInputChange} required></Box>
                            <button className="default collapsed" onClick={() => applyChangeRatioDialing()}>Modificar</button>
                        </div>
                    </div>
                </ModalWindow>
            ) : null}
            
            <div className="infoUserWrapper">
                <table className='fullWidth'>
                    <thead></thead>
                    <tbody>
                    <tr>
                        <td><a onClick={()=>setFilter(null)}>EJECUTIVOS EN SISTEMA</a></td>
                        <td className='right'><span className='badge'>{executives.length}</span></td>
                    </tr>
                    <tr>
                        <td><a onClick={() => setFilter({ code:'RINGING', desc:'RINGING'})}>RINGING</a></td>
                        <td className='right'><span className='badge'>{executives.filter(ex => ex.logDetails.eventCode ==='RINGING').length}</span></td>
                    </tr>
                    <tr>
                        <td><a onClick={()=>setFilter({code:'ACTIVE', desc:'AGENTES DISPONIBLES'})}>AGENTES DISPONIBLES</a></td>
                        <td className='right'><span className='badge'>{executives.filter(ex => ex.logDetails.eventCode==='ACTIVE').length}</span></td>
                    </tr>
                    <tr>
                        <td><a onClick={()=>setFilter({code:'INGRESANDO GESTIÓN', desc:'AGENTES INGRESANDO GESTIÓN'})}>AGENTES INGRESANDO GESTIÓN</a></td>
                        <td className='right'><span className='badge'>{executives.filter(ex => ex.logDetails.eventCode==='INGRESANDO GESTIÓN').length}</span></td>
                    </tr>
                    <tr>
                        <td><a onClick={()=>setFilter({code:'PAUSED', desc:'AGENTES EN PAUSA'})}>AGENTES EN PAUSA</a></td>
                        <td className='right'><span className='badge'>
                            {executives.filter(ex => 
                                ex.logDetails.eventCode!=='RINGING' &&
                                ex.logDetails.eventCode!=='ACTIVE' &&
                                ex.logDetails.eventCode!=='INGRESANDO GESTIÓN' &&
                                ex.logDetails.eventCode!=='LOGGED'
                            ).length}</span>
                        </td>
                    </tr>
                    <tr>
                        <td><a onClick={()=>setFilter({code:'LOGGED', desc:'EJECUTIVOS LOGEADOS'})}>EJECUTIVOS LOGEADOS</a></td>
                        <td className='right'><span className='badge'>{executives.filter(ex => ex.logDetails.eventCode==='LOGGED').length}</span></td>
                    </tr>
                    
                    </tbody>
                </table>
                
            </div>

            <div className="contentSectionWrapper">
                <div className="enqueuedInfoWrapper">
                    <div className="enqueuedInfo outbound">
                        <h3>Outbound</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th className='vertical'><span>En espera</span></th>
                                    <th className='vertical'><span>Logeados</span></th>
                                    <th className='vertical'><span>Disponibles</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {callsInQueue.filter(ci => ci.type==='outbound').map((ciq, index) => {
                                    return (
                                        <tr key={index}>
                                            <td><a onClick={()=>setFilterByQueue({type:'OUTBOUND', queue:ciq.name, desc:'OUTBOUND ' + ciq.cnyDetails.name})}><span style={{'borderBottom':'2px solid' + ciq.cnyDetails.color}}>{ciq.cnyDetails.name}</span></a></td>
                                            <td className='right'>{ciq.count}</td>
                                            <td className='right'>{ciq.loggedIn}</td>
                                            <td className='right'>{ciq.available}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                
                    <div className="enqueuedInfo inbound">
                        <h3>Inbound</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th className='vertical'><span>En espera</span></th>
                                    <th className='vertical'><span>Logeados</span></th>
                                    <th className='vertical'><span>Disponibles</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {callsInQueue.filter(ci => ci.type==='inbound').map((ciq, index) => {
                                    return (
                                        <tr>
                                            <td><a onClick={()=>setFilterByQueue({type:'INBOUND', queue:ciq.name, desc:'INBOUND ' + ciq.cnyDetails.name})}><span style={{'borderBottom':'2px solid' + ciq.cnyDetails.color}}>{ciq.cnyDetails.name}</span></a></td>
                                            <td className='right'>{ciq.count}</td>
                                            <td className='right'>{ciq.loggedIn}</td>
                                            <td className='right'>{ciq.available}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="enqueuedInfo dialing">
                        <label>Discando</label>
                        <h1>{callsDialing}</h1>
                    </div>

                </div>

                {/* ------------------------------------------------------------------------------------------- */}
                
                <div className="infoInQueue">
                    <h3><a onClick={() => setInfoInQueueVisible(!infoInQueueVisible)}>Encolamientos ({queuedCallsDetail.length})<ArrowRight className={infoInQueueVisible ?'inline rotate90':'inline'}/></a></h3>
                    {infoInQueueVisible?(
                        <table>
                            <tbody>
                                {queuedCallsDetail.map((det, index) => {
                                    return (
                                        <tr key={index}><td>{det.queue}</td><td>{det.phone}</td></tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : null}
                </div>
                
                {/* ------------------------------------------------------------------------------------------- */}

                <div className="infoInQueue"> 
                    <h3><a onClick={() => setInfoCampaignsVisible(!infoCampaignsVisible)}>Campañas en curso ({currentConnectedCampaigns.length})<ArrowRight className={infoCampaignsVisible ?'inline rotate90':'inline'}/></a></h3>
                    {infoCampaignsVisible ? (
                        <table>
                            <tbody>
                                {currentConnectedCampaigns.map((cmp, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <span className='visibleOnlyXS' style={{ 'borderBottom': '2px solid' + cmp.cnyDetails.color }}>{cmp.cnyDetails.code}</span>
                                                <span className='hiddenXS' style={{ 'borderBottom': '2px solid' + cmp.cnyDetails.color }}>{cmp.cnyDetails.name}</span>
                                            </td>
                                            <td>{cmp.name}</td>
                                            <td className='right'>{Tools.fmtClNumber(cmp.itemCount)} registros</td>
                                            <td>Ratio {cmp.ratioDialing}</td>
                                            <td><div className="advanceMonitor"><div className="progressbar"><div className="ind grayscale" style={{ width: cmp.progress + "%" }}></div></div><div className="percentage">{cmp.progress}%</div></div></td>
                                            <td>
                                                <MoreMenu menuList={
                                                    [{
                                                        title: "Cambiar ratio discado",
                                                        action: () => { changeRatioDialing(cmp); },
                                                        visible: (cmp.type === 'PROGRESSIVE')
                                                    }]} />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ):null}
                </div>

                {/* ------------------------------------------------------------------------------------------- */}

                <div className="infoInQueue">
                    <h3><a onClick={() => setAbandonmentsVisible(!abandonmentsVisible)}>Abandonos ({abandonments.reduce((acc, obj) => acc + Number(obj.abandonments), 0)})<ArrowRight className={abandonmentsVisible ? 'inline rotate90' : 'inline'} /></a></h3>
                    {abandonmentsVisible ? (
                        <table>
                            <tbody>
                                {abandonments.map((abd, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{abd.queue}</td>
                                            <td>{abd.abandonments}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : null}
                </div>

                {/* ------------------------------------------------------------------------------------------- */}
                
                <div className="infoTable">
                    <h3 className='tableTitle'>Ejecutivos ({filteredExecutives.length})</h3>
                    <p className='filter'><Filter/> Filtro: ESTADO&nbsp;
                        {filter?(
                            <span>{filter.desc} <button className='small' onClick={()=>setFilter(null)}>Limpiar</button></span>):'Todos'} 
                    &nbsp;|&nbsp; 
                    {filterByQueue?(
                        <span>COLA {filterByQueue.desc} <button className='small' onClick={()=>setFilterByQueue(null)}>Limpiar</button></span>):
                        (<span>COLA CUALQUIERA</span>)
                    }
                    </p>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <a onClick={()=>setSortKey('executiveName')}>Ejecutivo</a>
                                    {sortKey==='executiveName'?('A'):null}
                                </th>
                                <th>Estado</th>
                                <th className='center'>
                                    <a onClick={()=>setSortKey('extension')}>Anexo</a>
                                    {sortKey==='extension'?('A'):null}
                                </th>
                                <th>OUTBOUND</th>
                                <th className='right'>TOTAL</th>
                                <th>INBOUND</th>
                                <th className='right'>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                        {filteredExecutives.map((executive, index) => {
                            return (
                                <tr key={index}>
                                    <td className='status'>
                                        <img src={executive.profilePicture} alt="" style={{width:'40px'}}/>
                                        <i className={executive.logDetails.eventCode === 'ACTIVE' ? 'status active' : executive.logDetails.eventCode === 'LOGGED' ? 'status waiting' : executive.logDetails.eventCode === 'RINGING' ? 'status calling' : 'status paused'}/>
                                    </td>
                                    <td>{executive.name}</td>
                                    <td>{executive.logDetails.eventDesc}<br/>
                                        {Tools.ftCL(executive.logDetails.startDate)} (<ReactTimeAgo date={new Date(executive.logDetails.startDate)} timeStyle="twitter" />)
                                    </td>
                                    <td className='center'>{executive.extension}</td>
                                    <td>
                                        {Tools.isEmpty(executive.cmpDetails)?(<span className="filler"/>):null}
                                        {executive.cmpDetails.cnyDetails?(
                                            <span style={{'borderBottom':'2px solid' + executive.cmpDetails.cnyDetails.color}}>{executive.cmpDetails.cnyDetails.code}</span>
                                        ):null} &nbsp;
                                        {executive.cmpDetails.name}
                                    </td>
                                    <td className='right'>
                                        {executive.cmpDetails.aqDetails?(executive.cmpDetails.aqDetails.calls??0):(null)}
                                    </td>
                                    <td>
                                        {executive.lastInbound && executive.lastInbound.length>0 ?(
                                                
                                            executive.lastInbound.map((exec, index) => {
                                                return (
                                                    <span key={index}>
                                                        {index>0?(<span>, &nbsp;</span>):null}
                                                        <span style={{'borderBottom':'2px solid' + exec.color}}>{exec.code}</span> {exec.name}&nbsp;
                                                        ({exec.calls??0})
                                                    </span>
                                                );
                                            })
                                                
                                        ):(<span className="filler"/>)}
                                    </td>
                                    <td  className='right'>
                                        {
                                            executive.lastInbound?
                                            executive.lastInbound.reduce((acc, exec)=> { 
                                                return Number(acc) + Number(exec.calls??0);
                                            }, 0):0
                                        }
                                    </td>
                                    <td>
                                        <MoreMenu menuList={
                                            [{
                                                title: "Desconectar",
                                                action: () => { disconnectAgent(executive.extension)},
                                                visible: true
                                            }]}/>
                                    </td>
                                </tr>
                            )
                        })}

                        </tbody>
                    </table>

                </div>
            </div>

        </div>
    );
    
}

export default Monitor;
